export default __webpack_public_path__ + "static/media/Feature3(1).2ef43d07.png";